<div class="card">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">{{'QUẢN LÝ CẤU HÌNH HỆ THỐNG' | translate}}</h5>
      <button class="btn btn-success" (click)="openModal(content)">
        <i class="mdi mdi-plus mr-2"></i> {{'Thêm mới' | translate}}
      </button>
    </div>

    <div class="row mb-3">
      <div class="col-md-4">
        <label>{{'Khóa cấu hình' | translate}}</label>
        <input
          type="text"
          class="form-control"
          placeholder="{{'Nhập khóa cấu hình' | translate}}"
          [(ngModel)]="filter.key"
          (keyup.enter)="submitFilter()"
        />
      </div>
      <div class="col-md-4 d-flex align-items-end">
        <button class="btn btn-primary mr-2" (click)="submitFilter()">
          {{'Tìm kiếm' | translate}}
        </button>
        <button class="btn btn-secondary" (click)="clearFilter()">
          {{'Xóa' | translate}}
        </button>
      </div>
    </div>

    <div class="table-responsive">
      <table
        id="basic-datatable"
        class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
      >
        <thead>
          <tr class="bg-table">
            <th class="first-column">#</th>
            <th class="table-column">{{'Khóa cấu hình' | translate}}</th>
            <th class="table-column">{{'Giá trị cấu hình' | translate}}</th>
            <th class="table-column">{{'Mô tả' | translate}}</th>
            <th class="table-column">{{'Ngày tạo' | translate}}</th>
            <th class="table-column">{{'Ngày cập nhật' | translate}}</th>
            <th width="100" class="table-column">{{'Quản lý' | translate}}</th>
          </tr>
        </thead>
        <tbody *ngFor="let data of listData; let i=index">
          <tr>
            <td class="table-column">{{pageSize*(pageIndex-1) + i + 1}}</td>
            <td class="table-column">{{data.config_key}}</td>
            <td class="table-column" style="max-width: 350px; white-space: normal; word-break: break-word;">
              <pre *ngIf="isJsonValue(data.config_value); else plainValue" class="config-value-json">{{formatJsonValue(data.config_value)}}</pre>
              <ng-template #plainValue>{{data.config_value}}</ng-template>
            </td>
            <td class="table-column" style="max-width: 250px; white-space: normal; word-break: break-word;">
              {{data.description}}
            </td>
            <td class="table-column">
              {{data.created_at | date:'dd/MM/yyyy HH:mm':'GMT'}}
            </td>
            <td class="table-column">
              {{data.updated_at | date:'dd/MM/yyyy HH:mm':'GMT'}}
            </td>
            <td class="py-2 table-column text-center">
              <div class="d-flex" style="gap: 5px;">
                <a
                  class="font-size-18"
                  href="javascript: void(0);"
                  ngbTooltip="{{'FORM.Edit' | translate}}"
                  placement="bottom-left"
                  (click)="onEdit(data, content)"
                >
                  <i class="mdi mdi-account-edit"></i>
                </a>
                <a
                  class="font-size-18 text-danger"
                  href="javascript: void(0);"
                  ngbTooltip="{{'FORM.Delete' | translate}}"
                  placement="bottom-left"
                  (click)="onDelete(data.id)"
                >
                  <i class="mdi mdi-delete"></i>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!listData?.length">
          <tr>
            <td colspan="7" class="text-center">
              {{'Không có dữ liệu' | translate}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row justify-content-md-between align-items-md-center mt-2">
      <div class="col-sm-12 col-md-5">
        <div
          class="dataTables_info mb-2"
          id="tickets-table_info"
          role="status"
          aria-live="polite"
        >
          {{'Hiện' | translate}} {{pageSize*pageIndex - pageSize + 1}} {{'đến' |
          translate}} {{pageSize*pageIndex}} {{'trong' | translate}}
          {{totalCount}} {{'mục' | translate}}
        </div>
      </div>
      <div
        class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end"
      >
        <div class="text-md-right float-md-right pagination-rounded">
          <ngb-pagination
            [collectionSize]="totalCount"
            [(page)]="pageIndex"
            [pageSize]="pageSize"
            [maxSize]="5"
            [ellipses]="true"
            (pageChange)="fetchData()"
          >
          </ngb-pagination>
        </div>
        <div class="dataTables_length ml-3" id="tickets-table_length">
          <label class="d-inline-flex align-items-center mb-0">
            {{'Hiện' | translate}}
            <select
              name="tickets-table_length"
              aria-controls="tickets-table"
              [(ngModel)]="pageSize"
              (ngModelChange)="pageIndex = 1; fetchData()"
              class="custom-select custom-select-sm form-control form-control-sm mx-2"
            >
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            {{'mục' | translate}}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{(formData.value.id ? 'Chỉnh sửa cấu hình' : 'Thêm mới cấu hình') | translate}}
    </h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="saveData()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-3 col-form-label required_label"
              >{{'Khóa cấu hình' | translate}}</label
            >
            <div class="col-md-9">
              <input
                type="text"
                class="form-control"
                formControlName="config_key"
                [ngClass]="{'is-invalid': submitted && form.config_key.errors}"
              />
              <div class="invalid-feedback" *ngIf="submitted && form.config_key.errors?.required">
                {{'Vui lòng nhập khóa cấu hình' | translate}}
              </div>
              <div class="invalid-feedback" *ngIf="submitted && form.config_key.errors?.maxlength">
                {{'Khóa cấu hình tối đa 100 ký tự' | translate}}
              </div>
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-3 col-form-label"
              >{{'Giá trị cấu hình' | translate}}</label
            >
            <div class="col-md-9">
              <textarea
                class="form-control"
                rows="5"
                formControlName="config_value"
              ></textarea>
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-3 col-form-label"
              >{{'Mô tả' | translate}}</label
            >
            <div class="col-md-9">
              <textarea
                class="form-control"
                rows="2"
                formControlName="description"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px;"
            (click)="modal('close click')"
          >
            {{'Đóng' | translate}}
          </button>
          <button type="submit" class="btn btn-success btn-lg" style="width: 150px;">
            {{'Lưu' | translate}}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
